import React from "react";

import { P, SectionHeading, SectionMainWrapper, SectionSubHeading, SectionWrapper, Text } from "../../Styles/style";

import arbscan from "../../../assets/images/ethscan.png"
import telegram from "../../../assets/images/telegram.png"
import uniswap from "../../../assets/images/uniswap.png"
import dextools from "../../../assets/images/dextools.png"
import twitter from "../../../assets/images/twitter.png"
import mainimg from "../../../assets/images/mainimg.png"
import styled from "@emotion/styled";
import { Container, Grid, useTheme } from "@mui/material";

const VideoBK = styled.img`
  width: 100%;
  height: auto;
  max-width:600px;
`;
const GridHEading = styled(Grid)`
padding: 50px 0 0;
display: flex;
align-items: center;
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const GridVideo = styled(Grid)`
/* mix-blend-mode: lighten; */
`;
const Div = styled.div`
padding:50px 0 20px;
 display:flex ;
 align-items:center;
 @media screen and (max-width:470px){
    display: block;

 }
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;

@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-right: 10px;
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const Arbspoan = styled.span`
 color: ${(props) => props.theme.textTertiary};
  font-size: ${(props) => props.fs ? props.fs : "calc(45px + (26 - 22) * ((100vw - 146px) / (1600 - 250)))"};
font-family: "P-R";
  width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  padding: ${(props) => (props.p ? props.p : "10px 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  font-weight: 200;
  margin: ${(props) => (props.m ? props.m : "")};

  @media screen and (max-width: 972px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 20) * ((100vw - 16px) / (1600 - 250)))"};
  }
  @media screen and (max-width: 419px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 10) * ((100vw - 26px) / (1600 - 250)))"};
  }
`
const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 25px;
padding: 10px 50px;
margin-right: 15px;
font-family:"Rockkb";
border:1px solid #000;
@media screen and (max-width:499px){
  padding: 8px 25px;

}

`
const Section1_Header = () => {
  const theme = useTheme()
  return (
    <SectionMainWrapper p="0rem 0" id="home">
      <Container maxWidth="xl">

        <GridHEading container >

          <GridImage xs={12} md={6}>
            <SectionHeading
              p="30px 0 20PX"
              m="0"
              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              Pepedoge
            </SectionHeading>
            <P
              maxWidth="80%"
              p="0 0 40px 0"
              m="0"

              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0"
            >
              Missed out on $DOGE and the latest $PEPE coin? Well we've got you covered. Look no further because PEPEDOGE brings you the best of both worlds with 1% tax or strings attached!
              <br />
              <br />
              Be a part of a small but ever-growing community of degens, memers and bulls. With the popularity of DOGE and Pepe coin still fresh in people's minds, PEPEDOGE presents itself as an amazing opportunity, allowing you to try your luck at bagging your next crazy moonshot.
            </P>
            <div data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-duration="500"
              data-aos-offset="0"
            >

              <BuyNow
                href="https://app.uniswap.org/#/swap?outputCurrency=0xf994cab2f787159725372004142a685ea9576824&chain=ethereum"
                target="_blank">
                Buy Now
              </BuyNow>
              <BuyNow bgColor={theme.textPrimary}
                Color={theme.textTertiary}
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="700"
                data-aos-offset="0"
                href="https://www.dextools.io/app/en/ether/pair-explorer/0xf994CAB2F787159725372004142a685EA9576824"
                target="_blank">
                View Chart
              </BuyNow>
            </div>
            <Div>
              <SectionSubHeading p="0px 20px 0px 0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="400"
                data-aos-offset="0">Find us on:</SectionSubHeading>
              <a href="https://t.me/pegecoineth" target="_blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={telegram} />
              </a>
              <a href="https://twitter.com/pegecoin_eth" target="_blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="900"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={twitter} />
              </a>
              <a href="https://etherscan.io/token/0xf994CAB2F787159725372004142a685EA9576824"
              target="blank"
                data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1000"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={arbscan} />
              </a>

              <a href="https://app.uniswap.org/#/swap?outputCurrency=0xf994cab2f787159725372004142a685ea9576824&chain=ethereum"  target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1100"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={uniswap} />
              </a>
              <a href="https://www.dextools.io/app/en/ether/pair-explorer/0xf994CAB2F787159725372004142a685EA9576824" target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1200"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={dextools} />
              </a>


            </Div>
          </GridImage>
          <GridVideo
            xs={12}
            md={6}
            data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <VideoBK src={mainimg} />

          </GridVideo>
        </GridHEading>
      </Container>
    </SectionMainWrapper>
  );
};

export default Section1_Header;
